import type { IconProps } from './../../models/icon';

export function HideIcon({
  width = 24,
  height = 24,
  secondaryColor = 'var(--color-200)',
  className = '',
}: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      width={width}
      height={height}
      className={className}
    >
      <g clipPath="url(#a)">
        <path
          fill={secondaryColor}
          fillRule="evenodd"
          d="M23.1217 12.0002C23.1217 11.5228 22.9644 11.0624 22.6801 10.708C20.8801 8.52868 16.7829 4.28577 12.0001 4.28577C7.21723 4.28577 3.12009 8.52868 1.32008 10.708C1.03579 11.0624 0.878418 11.5228 0.878418 12.0002C0.878418 12.4775 1.03579 12.9379 1.32008 13.2923C3.12009 15.4716 7.21723 19.7145 12.0001 19.7145C16.7829 19.7145 20.8801 15.4716 22.6801 13.2923C22.9644 12.9379 23.1217 12.4775 23.1217 12.0002ZM12.0001 8.57148C13.8936 8.57148 15.4287 10.1065 15.4287 12.0001C15.4287 12.9468 15.0449 13.804 14.4244 14.4244L9.57571 9.57569C10.1962 8.95524 11.0533 8.57148 12.0001 8.57148Z"
          clipRule="evenodd"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M6.22152 6.21331C7.92336 5.10742 9.89534 4.28577 12.0001 4.28577C16.7829 4.28577 20.8801 8.52868 22.6801 10.708C22.9644 11.0624 23.1217 11.5228 23.1217 12.0002C23.1217 12.4775 22.9644 12.9379 22.6801 13.2923C21.6879 14.4936 19.9976 16.3219 17.8795 17.721M14.5715 19.3195C13.7446 19.5697 12.884 19.7145 12.0001 19.7145C7.21723 19.7145 3.12009 15.4716 1.32008 13.2923C1.03579 12.9379 0.878418 12.4775 0.878418 12.0002C0.878418 11.5228 1.03579 11.0624 1.32008 10.708C1.89038 10.0175 2.69126 9.1199 3.67149 8.21572"
        />
        <path
          fill="transparent"
          d="M12.0001 15.4286C13.8937 15.4286 15.4287 13.8935 15.4287 12C15.4287 10.1064 13.8937 8.57141 12.0001 8.57141C10.1066 8.57141 8.57153 10.1064 8.57153 12C8.57153 13.8935 10.1066 15.4286 12.0001 15.4286Z"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M14.4246 14.4245C15.7636 13.0855 15.7636 10.9147 14.4246 9.57573C13.0857 8.2368 10.9149 8.2368 9.57593 9.57573"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M23.1431 23.1429L0.857422 0.857178"
        />
      </g>
      <defs>
        <clipPath id="a">
          <rect width="24" height="24" fill="transparent" />
        </clipPath>
      </defs>
    </svg>
  );
}
